/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Dropdown from '../../../legacy/flux/components/form/Dropdown.react';
// import CheckboxQuestion from './CheckboxQuestion.react';
// import RadioQuestion from './RadioQuestion.react';
import Text from '../../../legacy/flux/components/form/Text.react';
import TextareaQuestion from '../../../legacy/flux/components/questions/TextareaQuestion.react';

const ExtendedFormQuestion = (props) => {
  const {
    id,
    title,
    type,
    answers,
    onChange,
    errorMsg,
  } = props;

  let questionItem = null;
  switch (type) {
    case 'dropdown':
      questionItem = (
        <Dropdown
          setFormData={onChange}
          name={id}
          options={answers}
          valueKey="value"
          label="label"
          errorMsg={get(translations, errorMsg, errorMsg)}
        />
      );
      break;
    case 'checkbox':
      questionItem = (
        <div className="tcr">
          {`ERROR: Unknown question type: ${type}`}
        </div>
      );
      // TODO
      /* questionItem = (
        <CheckboxQuestion
          setFormData={this.setFormData}
          name={this.state.question.name}
          title={this.state.question.title}
          answers={this.state.question.answers}
        />
      ); */
      break;
    case 'radio':
      questionItem = (
        <div className="tcr">
          {`ERROR: Unknown question type: ${type}`}
        </div>
      );
      // TODO
      /* questionItem = (
        <RadioQuestion
          setFormData={this.setFormData}
          name={this.state.question.name}
          title={this.state.question.title}
          answers={this.state.question.answers}
        />
      ); */
      break;
    case 'text':
      questionItem = (
        <Text
          name={id}
          setFormData={onChange}
          errorMsg={get(translations, errorMsg, errorMsg)}
        />
      );
      break;
    case 'textarea':
      questionItem = (
        <TextareaQuestion
          name={id}
          setFormData={onChange}
          errorMsg={get(translations, errorMsg, errorMsg)}
        />
      );
      break;
    default:
      questionItem = (
        <div className="tcr">
          {`ERROR: Unknown question type: ${type}`}
        </div>
      );
  }

  return (
    <div>
      <div className="mtl mbs mlxs twb">{title}</div>
      {questionItem}
    </div>
  );
};

ExtendedFormQuestion.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
};

ExtendedFormQuestion.defaultProps = {
  answers: [],
  errorMsg: '',
};

export default ExtendedFormQuestion;
